/* eslint no-use-before-define: ["error", { "functions": false }] */
const INITIAL_STATE = {
  user: {},
  showProfile: false,
  isLoading: false,
  hasError: false,
};

const strategies = {
  '@user/PROFILE_REQUEST': profileRequest,
  '@user/PROFILE_REQUEST_SUCCESS': profileRequestSuccess,
  '@user/PROFILE_REQUEST_FAILURE': profileRequestFailure,
  '@user/SHOW_PROFILE': showProfile,
  '@user/HIDE_PROFILE': hideProfile,
  '@user/SIGN_OUT': signout,
  __default__: (state) => state,
};

export default function user(state = INITIAL_STATE, action) {
  const tranformer = strategies[action.type] || strategies.__default__;
  return tranformer(state, action);
}

function profileRequest(state, action) {
  return { ...state, isLoading: true, hasError: false };
}

function profileRequestSuccess(state, action) {
  const {
    payload: { user },
  } = action;

  return {
    ...state,
    user,
    isLoading: false,
    hasError: false,
  };
}

function profileRequestFailure(state, action) {
  return { ...state, showProfile: false, isLoading: false, hasError: true };
}

function showProfile(state, action) {
  return { ...state, showProfile: true };
}

function hideProfile(state, action) {
  return { ...state, showProfile: false };
}

function signout(state, action) {
  return {
    ...state,
    user: {},
    showProfile: false,
    isLoading: false,
    hasError: false,
  };
}
